const initDiretoresHome = () => {
  const listaDiretores = document.querySelectorAll('.conteudo-diretores .carousel.lista-limpa .diretores-item')
  const diretorPrincipal = document.querySelector('[data-principal="diretor"]')
  const btnNext = document.querySelector('.conteudo-diretores .slider-controls__arrows .next')
  const btnPrev = document.querySelector('.conteudo-diretores .slider-controls__arrows .prev')
  
  if(btnNext && btnPrev) {
    const proximo = () => {
      listaDiretores.forEach(item => {
        if(item.dataset.order === "0") {
          const img = diretorPrincipal.querySelector('.box-img img')
          let partes = img.src.split('/');
          partes[partes.length - 1] = item.dataset.img;

          img.src = partes.join('/')
          img.style.top = item.dataset.top
          diretorPrincipal.querySelector('.box-titulo-cargo h4').innerHTML = item.dataset.nome;
          diretorPrincipal.querySelector('.box-titulo-cargo span').innerHTML = item.dataset.cargo;
          diretorPrincipal.children[1].children[1].innerHTML = item.dataset.texto1;
          diretorPrincipal.children[1].children[2].innerHTML = item.dataset.texto2;
        }
      })
    }
    
    const anterior = () => {
      listaDiretores.forEach(item => {
        if(item.dataset.order === "0") {
          const img = diretorPrincipal.querySelector('.box-img img')
          let partes = img.src.split('/');
          partes[partes.length - 1] = item.dataset.img;

          img.src = partes.join('/')
          img.style.top = item.dataset.top
          diretorPrincipal.querySelector('.box-titulo-cargo h4').innerHTML = item.dataset.nome;
          diretorPrincipal.querySelector('.box-titulo-cargo span').innerHTML = item.dataset.cargo;
          diretorPrincipal.children[1].children[1].innerHTML = item.dataset.texto1;
          diretorPrincipal.children[1].children[2].innerHTML = item.dataset.texto2;
        }
      })
    }

    btnNext.addEventListener("click", () => {
      proximo()
    })
    
    btnPrev.addEventListener("click", () => {
      anterior()
    })
  }
}

export default initDiretoresHome